import { useEffect, useRef } from "react";

const CumulusCartVisitorTracking = () => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    // Cumulus CL Pixel
    const ordnumber = Math.floor(Math.random() * 1e13);
    const img = document.createElement("img");
    img.src = `https://trkn.us/pixel/conv/ppt=23632;g=airport_home_appliance_cart_visitors;gid=57613;ord=${ordnumber};v=120`;
    img.alt = "";
    img.width = 1;
    img.height = 1;
    img.style.display = "none";
    document.body.appendChild(img);

    // Simpli.fi Script
    const script = document.createElement("script");
    script.src =
      "https://tag.simpli.fi/sifitag/2b74dca8-39cf-4fbd-aa83-ba20167720e1";
    script.async = true;
    document.body.appendChild(script);

    // Clean up on unmount
    return () => {
      if (img.parentNode) img.parentNode.removeChild(img);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);

  return null;
};

export default CumulusCartVisitorTracking;
